export const QUERY_PARAMS = {
  SEARCH: 'search',
  CATEGORY: 'category',
} as const;
